import React, { FC } from "react";
import { PrivacyPolicyInfo } from "src/page-components/privacy-policy/PrivacyPolicyInfo";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const PrivacyPolicy: FC = () => (
  <MetadataWrapper name="privacy_policy">
    <PageWrapper mainClassName="mt-19 py-20">
      <PrivacyPolicyInfo />
    </PageWrapper>
  </MetadataWrapper>
);

export default PrivacyPolicy;
